import { Component, ViewChild, TemplateRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../../services/invoice/invoice.service';
import { DashboardServicesService } from '../../../services/dashboard-services/dashboard-services.service';
import { Observable } from 'rxjs';
import { LogDto } from '../../../models/dto/log.dto';
import { Action } from '../../../models/enums/action.enum';
import { LogService } from '../../../services/log/log.service';
import { Screen } from '../../../models/enums/screen.enum';
import * as jwt_decode from "jwt-decode";
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { selectAuthState } from '../../../core/auth/_selectors/auth.selectors';
import { orderInProgressService } from '../orders-in-progress/orders-in-progress.service';
import { TrackingServiceService } from '../../../services/tracking-service.service';
import { formatDate } from '@angular/common';
import { DatePipe } from '@angular/common';

import { url } from 'inspector';
import { Subscription } from 'rxjs/Subscription';
import { TitleCasePipe } from '@angular/common';
import { TARJA_STATUS_NAMES } from '../../transfer-request/constants';

declare var $: any;

@Component({
  selector: 'kt-share-order',
  templateUrl: './share-order.component.html',
  styleUrls: ['./share-order.component.scss']
})
export class ShareOrderComponent implements OnInit {
  private titleCasePipe = new TitleCasePipe();
  @ViewChild('impedimento', { static: true }) impedimento: TemplateRef<any>;
  @ViewChild('sharebl', { static: true }) sharebl: TemplateRef<any>;
  @ViewChild('sharedata', { static: true }) sharedata: TemplateRef<any>;
  @ViewChild('calificar', { static: true }) calificar: TemplateRef<any>;
  /**
   * **************
   * Boolean Variables
  */
  public viewDetail = false;
  public expandupdates = false;
  public dropDownExpand = false;
  public billOfLadingDropdown = false;
  public bookmarkactive = false;
  public active = false;
  public innerindexactive = false;
  public rightsidepanel = false;
  public almacenGeneral = false;
  public gestionAduanal = false;
  public almacenDesconsolidacion = false;
  public transpTerrestre = false;
  public transpAereo = false;
  public transpMaritima = false;
  public innerInExactive = false;
  public commentsdisable: boolean = false;
  public Client: boolean = false;
  ratingstardisable: boolean = false;
  ratingcomments: boolean = false;
  public blExpandUpdates = true;
  public tarjaDetailsActive = true;
  public tarjaDetailsDropdown = true;
  public sharelink: any;
  public isChecked: any;
  public indexno: any;
  public tarjaIndexNo = 0;
  public innerIndexNo: any;
  public bls: any = [];
  public blSelected: string = '';
  public blData: any = {}
  public blErrors: any = {}
  public searchForm: FormGroup;
  public orderInProgressList: any = [];
  public clientRole: any = [];
  public page: number = 1;
  public invoicePage: number = 1;
  public notRows: boolean;
  public impedementActiveIndex: any;
  public selectedData: any;
  public selectedTarjaData: any;
  public title: any;
  public status: "";
  public containersList: any = [];
  public tarjasList: any = [];
  public customesList: any = [];
  public wisReferencesList: any = [];
  public blThStatusDetails: any = [];
  public windipList: any;
  public poList: any;
  public blStatusDetails: any;
  public blStatusDetailsHorizontal: any;
  public blThStatusDetils: any = [];
  public invoices: any;
  public payload$: Observable<any>;
  public actionId: any;
  public sortOrder: any;
  public orderOn: any = 'dt';
  public size: number = 10;
  public search: any = '';
  public impedimentTitle: any = '';
  public getSystem: any;
  public allStatus: any;
  public firstDate: any;
  public lastDate: any;
  public transportData: any;
  public yesterday: any;
  public transpTerrestreDetails: any;
  public indexNo: any;
  public transpTerrestreStatus = [];
  public selectedTraja: any;
  public associatedBls = [];
  public tarjaDetails: any;
  public blHijoNumber: any;
  public documentList = [];
  public blNumber: any = '';
  public sharedtype: any;
  public comments: any;
  blnum: any;
  ratingstar: any = {};
  subscription: Subscription;
  poPort = '';
  public selectedCompanyID;
  statusLabel: { [key: string]: string } = {
    'DECLARADO': 'Declaración Aduanal Completada',
    'DESPACHADO / LIBERADO': 'Liberado Por Aduanas',
    'Descargado': 'Carga Disponible para Verificación',
    'Facturado': 'Disponible para Pago'
  };
  allowedTrackingStatus: string[] = [
    'Fecha Deseada de Servicio',
    'Inicio de Servicio',
    'Servicio Completado'
  ];


  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private dashboardServices: TrackingServiceService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private store: Store<AppState>,
    private logService: LogService,
    private router: Router,
    private orderinprogress: orderInProgressService,
    private datePipe: DatePipe
  ) {
    $('body').tooltip({ selector: '[data-toggle=tooltip]' });
    this.subscription = this.orderinprogress.getData().subscribe(x => {
      this.blnum = x.blnumber
    });
  }

  numSequence(n: number): Array<number> {
    return Array(n);
  }

  ngOnInit() {
    this.generateForm();
    this.route.params.subscribe(params => {
      this.title = 'Localiza tus Cargas'
      this.searchForm.controls.referenceNo.setValue(params.type);
      if (params.sharing) {
        this.searchForm.controls.referenceType.setValue(params.sharing)
      }
    })
    this.selectedCompanyID = localStorage.getItem("SelectedcompanyID");
    this.getOrderInProgressList();
    this.integrateAuditApi();
    var now = new Date();
    this.yesterday = formatDate(
      now.setDate(now.getDate() - 1),
      'yyyy-MM-dd',
      'en'
    );
  }

  integrateAuditApi() {
    this.payload$ = this.store.pipe(select(selectAuthState));
    this.payload$.subscribe(res => {
      let tokenData = jwt_decode(res.authToken)
      this.logService.postWithPayload(<LogDto>{
        ActionId: this.actionId,
        ScreenId: Screen.IniCio,
        Json: '',
        UserName: res.user.fullname,
        Email: res.user.email,
        ClientId: tokenData['https://mardom.com/clientId'] == '' ? null : tokenData['https://mardom.com/clientId'],
        RoleName: tokenData['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'][0]
      },
        res.authToken);
    })
  }

  searchPedido() {
    this.page = 1
    let datefrom = this.searchForm.controls.fromDate.value;
    let dateto = this.searchForm.controls.toDate.value;
    this.billOfLadingDropdown = false;
    this.active = false;
    this.rightsidepanel = false
    if ((datefrom || dateto) && (datefrom && dateto) && (datefrom > dateto)) {
      this.toastrService.info("La fecha en 'Fecha Hasta' debe de ser mayor a 'Fecha Desde'.");
    } else if (this.searchForm.controls.referenceType.value) {
      this.getOrderInProgressList();
    } else {
      this.getOrderInProgressList();
    }
  }

  private getOrderInProgressList(): void {
    const payload = this.buildOrderInProgressPayload();
    this.dashboardServices.getOrderInProgressList(this.page, this.size, payload).subscribe({
      next: ({ orders, total }) => {
        this.orderInProgressList = payload.referenceNo && orders.length ? [orders[0]] : orders;
        this.orderInProgressList.total = total;
        this.notRows = total === '0';
        if (this.blNumber && this.orderInProgressList.length) {
          this.openDetailsBill(0, this.orderInProgressList[0]);
        }
        this.changeDetectorRef.detectChanges();
      },
      error: () => this.showError()
    });
  }

  private buildOrderInProgressPayload() {
    const {
      fromDate,
      toDate,
      referenceNo,
      status,
      referenceType
    } = this.searchForm.getRawValue();

    return {
      fromDate: fromDate || null,
      toDate: toDate || null,
      referenceNo: referenceNo || this.blNumber,
      status: status || this.status,
      referenceType,
      orderOn: this.orderOn || 'dt',
      orderBy: this.sortOrder || 'desc',
      startWith: this.search
    };
  }

  openDetailsBill(i: any, order) {
    //debugger
    if (this.selectedData && this.selectedData.blNumber == order && order.blNumber) {
      this.selectedData = order;
    }
    else {
      this.selectedData = order;
      this.containersList = [];
      this.tarjasList = [];
      this.customesList = [];
      this.wisReferencesList = [];
      this.dashboardServices.getAllReferences(order.blNumber, order.system).subscribe(res => {
        this.tarjasList = res && res.tarjas && res.tarjas.tally ? res.tarjas.tally : [];
        if (res.contenedores.containers != null) {
          this.removeDuplicatedContainers(res);
        }
        this.documentList = res.documents;
        this.poList = res.poNumber
        this.changeDetectorRef.detectChanges();
      }, (error) => {
        this.toastrService.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo serviciosit@mardom.com');
      })
    }
    this.billOfLadingDropdown = this.indexno != i ? true : !this.billOfLadingDropdown
    this.active = this.indexno != i ? true : !this.active;
    this.indexno = i;
    this.rightsidepanel = this.active ? true : false;
    this.orderinprogress.sendData(
      {
        calificar: this.rightsidepanel,
        blnumber: order.blNumber
      }
    );
  }

  private removeDuplicatedContainers(containers: any[]): void {
    containers.forEach(container => {
      if (!this.containersList.includes(container)) {
        this.containersList.push(container);
      }
    });
  }

  private showError(): void {
    this.toastrService.error(
      'Ha ocurrido un error, favor intente de nuevo. Si el error persiste, comunicarse al correo serviciosit@mardom.com'
    );
  }

  previousPage(): void {
    localStorage.clear();
    if (this.viewDetail) {
      this.closeDetailView();
      return;
    }

    if (this.billOfLadingDropdown) {
      this.closeBillOfLadingPanel();
      return;
    }

    this.router.navigate(['login']);
  }

  private closeDetailView(): void {
    this.viewDetail = false;
    this.blExpandUpdates = true;
    this.billOfLadingDropdown = true;
    this.active = !this.active;
    this.firstDate = '';
    this.lastDate = '';
    this.gestionAduanal = false;
    this.almacenDesconsolidacion = false;
    this.blNumber = '';
    this.rightsidepanel = true;

    this.notifyOrderInProgress(false, '');
  }

  private closeBillOfLadingPanel(): void {
    this.billOfLadingDropdown = false;
    this.rightsidepanel = false;
    this.getOrderInProgressList();
  }

  private notifyOrderInProgress(
    calificar: boolean,
    blnumber: string
  ): void {
    this.orderinprogress.sendData({
      calificar,
      blnumber
    });
  }

  clearFilter(): void {
    this.page = 1;
    this.sortOrder = '';
    this.orderOn = '';
    this.search = '';
    this.indexno = -1;
    this.blNumber = '';
    this.rightsidepanel = false;

    this.resetSearchForm();
    this.resetServicesFilter();

    this.router.navigate(['/order']);
    this.getOrderInProgressList();
  }

  private resetSearchForm(): void {
    this.searchForm.patchValue({
      fromDate: '',
      toDate: '',
      referenceNo: '',
      referenceType: 'bl',
      status: this.status
    });
  }

  private resetServicesFilter(): void {
    this.almacenGeneral = false;
    this.gestionAduanal = false;
    this.almacenDesconsolidacion = false;
    this.transpTerrestre = false;
    this.transpAereo = false;
    this.transpMaritima = false;
  }

  generateForm() {
    this.searchForm = this.formBuilder.group({
      status: [''],
      fromDate: '',
      toDate: '',
      referenceType: ['bl'],
      referenceNo: ''
    });
  }

  onPageChangeInvoice(event) {
    this.invoicePage = event;
  }

  share(order) {
    let sharedtype = '';
    if (order.system == 'WINDIP') {
      sharedtype = 'bl';
    } else if (order.system == 'WIS') {
      sharedtype = 'agenda';
    }
    else {
      sharedtype = 'bl';
    }
  }

  getTarjasDetailsList(order: any): void {
    if (!order) {
      return;
    }

    if (!this.tarjasList.length) {
      this.blHijoNumber = '';
      this.tarjaDetails = null;
      this.getBlDetailsStatus();
      return;
    }

    this.dashboardServices
      .getTarjasDetails(this.tarjasList, order.blNumber)
      .subscribe({
        next: (response) => {
          this.tarjaDetails = response;
          this.blHijoNumber = response[0].blNumber;
          this.almacenDesconsolidacion = true;

          this.getBlDetailsStatus();
          this.changeDetectorRef.detectChanges();
        },
        error: () => {
          this.toastrService.error(
            'Ha ocurrido un error, favor intente de nuevo. Si el error persiste, comunicarse al correo mardomgo@mardom.com'
          );
        }
      });
  }

  getBlDetailsStatus(): void {
    //debugger
    this.resetServiceFlags();

    this.tarjaDetailsDropdown = true;
    this.tarjaDetailsActive = true;
    this.tarjaIndexNo = 0;

    const blNumber = this.blHijoNumber || this.selectedData.blNumber;
    const system = this.selectedData.system;

    if (!blNumber || !system) {
      return;
    }

    this.dashboardServices.getConsolidateTracking(blNumber, system).subscribe({
      next: (response) => {
        //debugger
        this.billOfLadingDropdown = false;
        this.active = false;
        this.viewDetail = true;

        this.allStatus = response;
        this.blStatusDetails = response.thEvents;
        this.blStatusDetailsHorizontal = response.thEvents;
        this.getSystem = response.systems;

        const type = this.tarjaDetails
          ? 'TH'
          : response.systems[0];

        if (type) {
          this.updateStatus(type);
        }

        this.changeDetectorRef.detectChanges();
      },
      error: () => {
        this.toastrService.error(
          'Ha ocurrido un error, favor intente de nuevo. Si el error persiste, comunicarse al correo serviciosit@mardom.com'
        );
      }
    });
  }

  private resetServiceFlags(): void {
    this.almacenGeneral = false;
    this.gestionAduanal = false;
    this.transpTerrestre = false;
    this.transpAereo = false;
    this.transpMaritima = false;
  }

  updateStatus(type: string): void {
    //debugger
    this.resetServiceFlags();

    switch (type) {
      case 'TH':
        this.updateTHStatus();
        break;

      case 'WINDIP':
        this.updateWindipStatus();
        break;

      case 'Silver Bullet':
        this.updateSilverBulletStatus();
        break;

      case 'Camiencito':
        this.updateCamiencitoStatus();
        break;

      case 'WIS':
        this.updateWisStatus();
        break;

      case 'PO Control':
        this.updatePOControlStatus();
        break;

      case 'TMS':
        this.updateTMSStatus();
        break;

      default:
        this.clearStatus();
        break;
    }
  }

  private updateTHStatus(): void {
    const events = this.allStatus.thEvents;

    this.setStatusEvents(events);

    this.removeStatus();
    this.verticalStatusRemove();

    this.viewDetail = true;
    this.almacenDesconsolidacion = true;
    this.blThStatusDetails = [];
  }

  private updateWindipStatus(): void {
    const events = this.allStatus.windipEvents;

    this.setStatusEvents(events);

    this.removeStatus();
    this.statusUpdate();
    this.verticalStatusRemove();

    this.viewDetail = true;
    this.gestionAduanal = true;
    this.blThStatusDetails = [];
  }

  private setStatusEvents(events: any[]): void {
    this.blStatusDetailsHorizontal = [...events];
    this.blStatusDetailsHorizontal = this.sortByDateH();

    this.blStatusDetails = [...events];
    this.blStatusDetails = this.sortByDate();

    this.setFirstAndLastDate();
  }

  private setFirstAndLastDate(): void {
    this.firstDate = this.blStatusDetails[0];
    //this.lastDate = this.blStatusDetails.[this.blStatusDetails.length - 1] = '';
  }

  private updateSilverBulletStatus(): void {
    const events = this.allStatus.silverBulletEvents || [];

    this.blStatusDetailsHorizontal = [...events];
    this.blStatusDetailsHorizontal = this.sortByDateH();

    this.blStatusDetails = [...events];

    this.transpTerrestreDetails = events[0].eventsList || [];

    this.transpTerrestre = true;
  }

  private updateCamiencitoStatus(): void {
    this.firstDate = '';
    this.lastDate = '';

    this.blStatusDetailsHorizontal = [];
    this.blStatusDetails = [];

    this.transportData = this.allStatus.camiencitoevents || [];

    this.transpTerrestre = true;
  }

  private updateWisStatus(): void {
    const events = this.allStatus.wisEvents || [];

    this.setStatusEvents(events);

    this.removeStatus();
    this.verticalStatusRemove();

    this.viewDetail = true;
    this.almacenGeneral = true;
  }

  private updatePOControlStatus(): void {
    const events = this.allStatus.poEvents || [];

    this.blStatusDetailsHorizontal = [...events];

    this.blStatusDetails = [...events];
    this.blStatusDetails = this.sortByDate();

    this.viewDetail = true;

    if (this.poPort === 'Aerea') {
      this.transpAereo = true;
    } else if (this.poPort === 'Maritima') {
      this.transpMaritima = true;
    }
  }

  private updateTMSStatus(): void {
    this.firstDate = '';
    this.lastDate = '';

    this.blStatusDetailsHorizontal = [];
    this.blStatusDetails = [];

    this.transportData = this.allStatus.tmSevents || [];

    this.transpTerrestre = true;
  }

  private clearStatus(): void {
    this.blStatusDetailsHorizontal = [];
    this.blStatusDetails = [];
    this.blThStatusDetails = [];

    this.firstDate = '';
    this.lastDate = '';
  }

  sortByDate() {
    return this.blStatusDetails.sort((a, b) => {
      return <any>new Date(b.trackdate) - <any>new Date(a.trackdate);
    });
  }

  sortByDateH() {
    return this.blStatusDetailsHorizontal.sort((a, b) => {
      return <any>new Date(b.trackdate) - <any>new Date(a.trackdate);
    });
  }

  verticalStatusRemove() {
    let verticalstatremove = this.blStatusDetails.filter(b => {
      return (
        (b.trackstatus != 'Facturado' && b.trackstatus != 'DesParaPago' && b.trackstatus != 'En proceso de verificación')
      );
    });
    this.blStatusDetails = verticalstatremove;
  }

  removeStatus() {
    let blStatusDetailss = this.blStatusDetailsHorizontal.filter(i => {
      return (
        (i.trackstatus != 'Facturado' && i.trackstatus != 'Solicitud De Gestion Aduanal Creada' && i.trackstatus != 'En Clasificacion Arancelaria' && i.trackstatus != 'DesParaPago' && i.trackstatus != 'En proceso de verificación' && i.trackstatus != 'Valores enviados para pago')
      );
    });
    this.blStatusDetailsHorizontal = blStatusDetailss;
  }

  statusUpdate() {
    let blstat = this.blStatusDetailsHorizontal.filter(a => {
      if (a.system == 'WINDIP') {
        return (
          a.trackstatus != 'Verificado'
        )
      }
    });
    this.blStatusDetailsHorizontal = blstat;
  }

  /** Estatus de seguimiento: nombre acordado si es estatus de tarja (Improvement 56825). */

  displayTrackStatus(status: string): string {

    if (status && TARJA_STATUS_NAMES[status]) {

      return TARJA_STATUS_NAMES[status];

    }

    return this.titleCasePipe.transform(status);

  }


  getStatusLabel(status: string): string {
    return this.statusLabel[status] || TARJA_STATUS_NAMES[status] || status;
  }

  getFilteredStatuses(): any[] {
    return (this.blStatusDetailsHorizontal)
      .filter(status => this.statusLabel[status.trackStatus]);
  }

  openTarjaDetails(i: any, tarja, id) {
    if (this.blHijoNumber != tarja.blNumber) {
      this.blHijoNumber = tarja.blNumber;
      this.getDetailsStatus(tarja.system, id);
    }
    this.tarjaDetailsDropdown = this.tarjaIndexNo != i ? true : !this.tarjaDetailsDropdown;
    this.tarjaDetailsActive = this.tarjaIndexNo != i ? true : !this.tarjaDetailsActive;
    this.tarjaIndexNo = i;
  }

  getDetailsStatus(system, id) {
    //debugger
    this.almacenGeneral = false;
    this.gestionAduanal = false;
    this.transpTerrestre = false;
    this.transpAereo = false;
    this.transpMaritima = false;
    this.tarjaDetailsDropdown = true;
    this.tarjaDetailsActive = true;
    this.tarjaIndexNo = 0;
    if (system == 'WIS' && id > 0) {
      this.toastrService.warning(
        'Si desea ver los detalles desde WIS, se debe consultar desde el numero de agenda'
      );
    } else {
      this.dashboardServices
        .getConsolidateTracking(
          this.blHijoNumber ? this.blHijoNumber : this.selectedData.blNumber,
          system
        )
        .subscribe(
          res => {
            //debugger
            this.billOfLadingDropdown = false;
            this.active = false;
            this.viewDetail = true;
            this.allStatus = res;
            this.blStatusDetails = res.thEvents;
            this.blStatusDetailsHorizontal = res.thEvents;
            this.getSystem = res.systems;
            this.updateStatus(this.tarjaDetails ? 'TH' : res.systems[0]);
            this.changeDetectorRef.detectChanges();
          },
          error => {
            this.toastrService.error(
              'Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo serviciosit@mardom.com'
            );
          }
        );
    }
  }

  changeImpedementOnTarjaList(index, tarja) {
    this.selectedTarjaData = '';
    this.impedimentTitle = '';
    this.impedementActiveIndex = index;
    this.selectedTarjaData = tarja;
    this.Client = this.clientRole.includes('Client');
    if (this.selectedTarjaData.impediment == false) {
      this.impedimentTitle =
        'Desea Activar el impedimento para todas las tarjas';
    } else if (this.selectedTarjaData.impediment == true) {
      this.impedimentTitle = 'Desea desactivar el impedimento para la tarja?';
    }
    this.modalService.open(this.impedimento, {
      size: 'm',
      backdrop: 'static',
      centered: true
    });
  }

  openTranspTerrestreDetails(i, data) {
    this.transpTerrestreDetails = data.eventsList;
    this.billOfLadingDropdown = this.indexNo != i ? true : !this.billOfLadingDropdown;
    this.indexNo = i;
    this.innerIndexNo = -1;
    this.changeDetectorRef.detectChanges();
  }

  openTranspTerrestreDetailsStatus(data: any, index: number): void {
    //debugger
    if (this.innerIndexNo === index && this.dropDownExpand) {
      this.dropDownExpand = false;
      this.innerIndexNo = null;
      this.innerInExactive = null;
      return;
    }
    this.dropDownExpand = true;
    this.innerIndexNo = index;
    this.blThStatusDetails = data.tracking || [];
    this.blThStatusDetails.forEach(x => {
      console.log('Original:', x.trackDate);
      console.log('Convertido:', new Date(x.trackDate));
    });
  }

  getTrackingReversed(tracking: any[]): any[] {
    if (!tracking) {
      return [];
    }
    return tracking.slice().reverse();
  }

  formatDate(date: Date): string {
    let formatted = this.datePipe.transform(date, 'd MMM yyyy h:mm a') || '';
    formatted = formatted.replace(/\.\s*/g, '').toUpperCase();

    return formatted.replace(/(\d{1,2} [A-Za-z]{3})(\d{4})/, '$1 $2');
  }

  serviceReferences = [
    {
      title: 'Gestión Aduanal',
      value: () => this.windipList
    },
    {
      title: 'Almacenes de Desconsolidación',
      value: () => this.tarjasList
    },
    {
      title: 'Transporte Terrestre',
      value: () => this.customesList
    },
    {
      title: 'Almacén General, Logístico, y Fiscal',
      value: () => this.wisReferencesList
    }
  ];
}